export const CPF_FORMAT = '###.###.###-##';

const INVALID_CPFS = [
  '00000000000',
  '11111111111',
  '22222222222',
  '33333333333',
  '44444444444',
  '55555555555',
  '66666666666',
  '77777777777',
  '88888888888',
  '99999999999',
];

function invalidate(number, at) {
  let add = 0;

  for (let i = 0; i < at; i += 1) {
    add += parseInt(number.charAt(i), 10) * (at + 1 - i);
  }

  let rev = 11 - (add % 11);

  if ([10, 11].indexOf(rev) > -1) {
    rev = 0;
  }

  if (rev !== parseInt(number.charAt(at), 10)) {
    return true;
  }

  return false;
}

export default function cpf(value = '') {
  if (['', undefined, null].includes(value)) {
    return false;
  }

  const number = String(value).replace(/\D/g, '');

  if (!number || number.length !== 11) {
    return true;
  }

  if (INVALID_CPFS.indexOf(number) > -1) {
    return true;
  }

  if (invalidate(number, 9)) {
    return true;
  }

  if (invalidate(number, 10)) {
    return true;
  }

  return false;
}

cpf.message = function message(value, options = {}) {
  return options.message || 'não é um CPF válido';
};
